import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { NetworkService } from '../shared/network.service';
@Injectable({
  providedIn: 'root'
})
export class HomeService {
  private pageChange = new BehaviorSubject('false');
  currentPage = this.pageChange.asObservable();

  constructor(private networkService: NetworkService,
    ) { }



 
  getSuggestionCircle(query) {
    return this.networkService.get("api/circles/circleList?"+query,null, null,'bearer');
  }
  getSuggestionMember(query:any){    
    return this.networkService.get("api/users/userList?hideSelf=true&"+query,null, null,'bearer');
  }
  getUserRole(query:any){
    return this.networkService.get("api/dropdowns/userRoles"+query,null, null,'bearer');
  }
  getUserDiseases(query:any){
    return this.networkService.get("api/dropdowns/diseases"+query,null, null,'bearer');
  }
  getUserProfileApi(qyery) {
    return this.networkService.get("api/users/profile"+qyery,null,null, 'bearer');
  }
  getReaarchInfo() {
    return this.networkService.get("api/dropdowns/researchFocus", null,null, 'bearer');
  }
  createConnetion(body:any) {
    return this.networkService.post("api/connectionRequests",body, null,'bearer');
  }
 
  updateUserProfile(body:any) {
    return this.networkService.put("api/users",body, null,'bearer');
  }
  uploadImage(image: any) {
    const formData = new FormData();
    formData.append("file",image);
    return this.networkService.uploadImages("api/s3upload/media-upload", formData, null, "bearer");
  }

  removeConnetion(id:any) {
    return this.networkService.delete("api/connections/"+id,null, null,'bearer');
  }
  UpdateConnetion(body:any) {
    return this.networkService.put("api/connectionRequests",body, null,'bearer');
  }

  getFormDetailApi(query:any) {
    return this.networkService.get("api/forms"+query,null, null,'bearer');
  }
  getHeaderSortApi(query:any) {
    return this.networkService.get("api/forms/header/mapping/sort/order"+query,null, null,'bearer');
  }
  editHeaderSortApi(body:any) {
    return this.networkService.put("api/forms/header/mapping/sort/order",body, null,'bearer');
  }

  

  getUserFormEditedDetailApi(query:any) {
    return this.networkService.get("api/forms/responses"+query,null, null,'bearer');
  }

  getFormAudits(query:any) {
    return this.networkService.get("api/forms/version/history?"+query,null, null,'bearer');
  }
  getTabularEntryApi(query:any) {
    return this.networkService.get("api/forms/tabular/data?"+query,null, null,'bearer');
  }

  getFormAuditsApi(query:any) {
    return this.networkService.get("api/forms/version/history?"+query,null, null,'bearer');
  }
  
  submitSingleTypeForm(body:any) {
    return this.networkService.put("api/forms/update/response",body, null,'bearer');
  }
  submitMultipleTypeForm(body:any) {
    return this.networkService.post("api/forms/submit/response",body, null,'bearer');
  }
  getPublicCircle(query:any){
    return this.networkService.get("api/circles/public/circles/names?"+query,null, null,'bearer');
  }
  getMentionNotify(query:any){
    return this.networkService.get("api/chats/my/mentions?"+query,null, null,'bearer');
  }
  getRecentActivity(query:any){
    return this.networkService.get("api/chats/recent/activity?"+query,null, null,'bearer');
  }
  putNotifyRead(body:any) {
    return this.networkService.put("api/chats/read/notification",body, null,'bearer');
  }
  getNotifications(query:any){
    return this.networkService.get("api/users/bell/notifications?"+query,null, null,'bearer');
  }
}

